export type Market = "SE" | "FI";
export type Brand = "ATG";

/**
 * @description A special pseudo locale used for in-context translation on the page, it is only available when the PAW_IN_CONTEXT_TRANSLATION feature flag is enabled and in non-production environments.
 */
export const InContextTranslationPseudoLocale = "af-ZA" as const;

export type LocaleString =
    | "sv-SE"
    | "fi-FI"
    | "sv-FI"
    | "pseudo-LOCALE"
    | "en-GB"
    | typeof InContextTranslationPseudoLocale;

export type LangCode = "sv" | "fi" | "sv" | "pseudo" | "en" | "af";

export type Currency = "SEK" | "EUR";

export type AvailableTimezone = "Europe/Stockholm" | "Europe/Helsinki";

export type MarketFeature =
    | "big9"
    | "shopshares"
    | "horse-correction-code"
    | "sportpool"
    | "user-gambling-summary"
    | "contact-language-switching";

export enum MarketProduct {
    horse = "horse",
    shop = "shop",
    sport = "sport",
    casino = "casino",
    authentication = "authentication",
}

// Add product specific features here
type MarketValues = {
    [MarketProduct.shop]: {
        currencyDecimalCount: number;
        hideTerminalSalesChannel: boolean;
        hideNewsLetter: boolean;
        hideFeedback: boolean;
    };
    [MarketProduct.authentication]?: {
        /**
         * Which HAAPI login/registration implementation to use for the market.
         * - `new`: new HAAPI flow implementation (TanStack Query based)
         * - `legacy`: previous flow implementation
         */
        haapiFlow: "new" | "legacy";
    };
    [MarketProduct.horse]?: undefined;
    [MarketProduct.sport]?: undefined;
    [MarketProduct.casino]?: undefined;
};

export type MarketConfig = {
    market: Market;
    brand: Brand;
    defaultLocale: LocaleString;
    availableLocales: Array<LocaleString>;
    currency: Currency;
    timezone: AvailableTimezone;
    disabledFeatures: Array<MarketFeature>;
    marketValues: MarketValues;
};
